import { render, staticRenderFns } from "./PlatformLeft.vue?vue&type=template&id=1ef2cf9c&scoped=true"
import script from "./PlatformLeft.vue?vue&type=script&lang=js"
export * from "./PlatformLeft.vue?vue&type=script&lang=js"
import style0 from "./PlatformLeft.vue?vue&type=style&index=0&id=1ef2cf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2cf9c",
  null
  
)

export default component.exports